(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pl3-fit-editorial"] && !Shopify.designMode) return;
  try {
    
  const pl3Navigation = [
    { href: '/', label: 'Home' },
    { href: '/collections/all', label: 'Shop' },
    { href: '/collections/all?sort_by=created-descending', label: 'New Arrivals' },
    { href: '/collections/body-care-collection', label: 'Body Care' },
    { href: '/collections/pl3-house-of-drip', label: 'Lip Gloss' },
    { href: '/collections/pl3-apparel', label: 'Apparel' },
    { href: '/collections/cup-collection', label: 'Accessories' },
    {
      href: '/collections/pl3-lifestyle-seasonal-collections',
      label: 'Collections',
      children: [
        { href: '/collections/pl3-lifestyle-seasonal-collections?filter.p.tag=Winter', label: 'Winter' },
        { href: '/collections/pl3-lifestyle-seasonal-collections?filter.p.tag=Spring', label: 'Spring' },
        { href: '/collections/pl3-lifestyle-seasonal-collections?filter.p.tag=Summer', label: 'Summer' },
        { href: '/collections/pl3-lifestyle-seasonal-collections?filter.p.tag=Fall', label: 'Fall' }
      ]
    }
  ];

  document.querySelectorAll('header nav ul, [role="banner"] nav ul').forEach((list) => {
    const originalItem = list.querySelector('li');
    if (!originalItem) return;

    const itemsByHref = new Map();
    list.querySelectorAll(':scope > li').forEach((item) => {
      const link = item.querySelector('a[href]');
      if (link) itemsByHref.set(new URL(link.href).pathname, item);
    });

    list.replaceChildren();
    pl3Navigation.forEach((section) => {
      const sourceItem = itemsByHref.get(new URL(section.href, window.location.origin).pathname) || originalItem;
      const item = sourceItem.cloneNode(true);
      const link = item.querySelector('a[href]');
      link.href = section.href;
      link.textContent = section.label;

      item.querySelectorAll('ul').forEach((submenu) => submenu.remove());
      item.classList.toggle('pl3-draft-nav__parent', Boolean(section.children));

      if (section.children) {
        link.setAttribute('aria-haspopup', 'true');
        const submenu = document.createElement('ul');
        submenu.className = 'pl3-draft-nav__submenu';
        section.children.forEach((child) => {
          const childItem = document.createElement('li');
          const childLink = document.createElement('a');
          childLink.href = child.href;
          childLink.textContent = child.label;
          childItem.appendChild(childLink);
          submenu.appendChild(childItem);
        });
        item.appendChild(submenu);
      } else {
        link.removeAttribute('aria-haspopup');
      }

      list.appendChild(item);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
